module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm_title"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_vm._v("Sigla")])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('table', {
    attrs: {
      "cellpadding": "2",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_vm._v("AN")]), _vm._v(" "), _c('td', [_c('i', [_vm._v("Armed Neutrality")]), _vm._v(". See PV.")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_vm._v("BA")]), _vm._v(" "), _c('td', [_c('i', [_vm._v("The Book on Adler")]), _vm._v(". Edited and translated by Howard V. Hong and Edna H. Hong. Princeton: Princeton University Press, 1998.")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_vm._v("CA")]), _vm._v(" "), _c('td', [_c('i', [_vm._v("The Concept of Anxiety")]), _vm._v(". Edited and translated by Reidar Thomte. Princeton: Princeton University Press, 1980.")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_vm._v("CD")]), _vm._v(" "), _c('td', [_c('i', [_vm._v("Christian Discourses and The Crisis and a Crisis in the Life of an Actress")]), _vm._v(". Edited and translated by Howard V. Hong and Edna H. Hong. Princeton: Princeton University Press, 1997.")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_vm._v("CI")]), _vm._v(" "), _c('td', [_c('i', [_vm._v("The Concept of Irony with Continual Reference to Socrates")]), _vm._v(". Edited and translated by Howard V. Hong and Edna H. Hong. Princeton: Princeton University Press, 1989.")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_vm._v("COR")]), _vm._v(" "), _c('td', [_c('i', [_vm._v("The Corsair Affair")]), _vm._v(". Edited and translated by Howard V. Hong and Edna H. Hong. Princeton: Princeton University Press, 1982.")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_vm._v("CUP")]), _vm._v(" "), _c('td', [_c('i', [_vm._v("Concluding Unscientific Postscript to “Philosophical Fragments.”")]), _vm._v(" Edited and translated by Howard V. Hong and Edna H. Hong. Princeton: Princeton University Press, 1992.")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_vm._v("EO")]), _vm._v(" "), _c('td', [_c('i', [_vm._v("Either/Or")]), _vm._v(" (2 vols.). Edited and translated by Howard V. Hong and Edna H. Hong. Princeton: Princeton University Press, 1987.")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_vm._v("EUD")]), _vm._v(" "), _c('td', [_c('i', [_vm._v("Eighteen Upbuilding Discourses")]), _vm._v(". Edited and translated by Howard V. Hong and Edna H. Hong. Princeton: Princeton University Press, 1990.")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_vm._v("FSE")]), _vm._v(" "), _c('td', [_c('i', [_vm._v("For Self-Examination; Judge for Yourself!")]), _vm._v(" Edited and translated by Howard V. Hong and Edna H. Hong. Princeton: Princeton University Press, 1990.")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_vm._v("FT")]), _vm._v(" "), _c('td', [_c('i', [_vm._v("Fear and Trembling")]), _vm._v(". Edited by C. Stephen Evans and Sylvia Walsh. Translated by Sylvia Walsh. Cambridge: Cambridge University Press, 2006.")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_vm._v("JFY")]), _vm._v(" "), _c('td', [_c('i', [_vm._v("Judge for Yourself!")]), _vm._v(" See FSE.")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_vm._v("JP")]), _vm._v(" "), _c('td', [_c('i', [_vm._v("Søren Kierkegaard’s Journals and Papers")]), _vm._v(" (7 vols.). Edited and translated by Howard V. Hong and Edna H. Hong. Bloomington: Indiana University Press, 1967–78.")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_vm._v("OMWA")]), _vm._v(" "), _c('td', [_c('i', [_vm._v("On My Work as an Author")]), _vm._v(". See PV.")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_vm._v("P")])]), _vm._v(" "), _c('td', [_c('i', [_vm._v("Prefaces; Writing Sampler")]), _vm._v(". Edited and Translated by Todd W. Nichol. Princeton: Princeton University Press, 1997.")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_vm._v("PC")]), _vm._v(" "), _c('td', [_c('i', [_vm._v("Practice in Christianity")]), _vm._v(". Edited and translated by Howard V. Hong and Edna H. Hong. Princeton: Princeton University Press, 1991.")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_vm._v("PF")]), _vm._v(" "), _c('td', [_c('i', [_vm._v("Philosophical Fragments")]), _vm._v(". Edited and translated by Howard V. Hong and Edna H. Hong. Princeton: Princeton University Press, 1985.")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_vm._v("PV")]), _vm._v(" "), _c('td', [_c('i', [_vm._v("The Point of View for My Work as an Author")]), _vm._v(", “The Single Individual,” "), _c('i', [_vm._v("On My Work as an Author")]), _vm._v(", and "), _c('i', [_vm._v("Armed Neutrality")]), _vm._v(". Edited and translated by Howard V. Hong and Edna H. Hong. Princeton: Princeton University Press, 1998.")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_vm._v("SLW")]), _vm._v(" "), _c('td', [_c('i', [_vm._v("Stages on Life’s Way")]), _vm._v(". Edited and translated by Howard V. Hong and Edna H. Hong. Princeton: Princeton University Press, 1988.")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_vm._v("SUD")]), _vm._v(" "), _c('td', [_c('i', [_vm._v("The Sickness unto Death")]), _vm._v(". Edited and translated by Howard V. Hong and Edna H. Hong. Princeton: Princeton University Press, 1980.")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_vm._v("TA")]), _vm._v(" "), _c('td', [_c('i', [_vm._v("Two Ages: The Age of Revolution and the Present Age. A Literary Review")]), _vm._v(". Edited and translated by Howard V. Hong and Edna H. Hong. Princeton: Princeton University Press, 1978.")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_vm._v("TM")]), _vm._v(" "), _c('td', [_c('i', [_vm._v("“The Moment” and Late Writings")]), _vm._v(". Edited and translated by Howard V. Hong and Edna H. Hong. Princeton: Princeton University Press, 1998.")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_vm._v("UDVS")]), _vm._v(" "), _c('td', [_c('i', [_vm._v("Upbuilding Discourses in Various Spirits")]), _vm._v(". Edited and translated by Howard V. Hong and Edna H. Hong. Princeton: Princeton University Press, 1993.")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_vm._v("WA")]), _vm._v(" "), _c('td', [_c('i', [_vm._v("Without Authority")]), _vm._v(". Edited and translated by Howard V. Hong and Edna H. Hong. Princeton: Princeton University Press, 1997.")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_vm._v("WL")]), _vm._v(" "), _c('td', [_c('i', [_vm._v("Works of Love")]), _vm._v(". Edited and translated by Howard V. Hong and Edna H. Hong. Princeton: Princeton University Press, 1995.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d529efa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/07_signal.vue
// module id = 78
// module chunks = 0